module.exports = __webpack_public_path__ + "static/media/ic-download-chrome.fe67e87b.svg";